import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type CreditCard02IconProps = IconProps

const CreditCard02Icon = forwardRef<SVGSVGElement, CreditCard02IconProps>(
  (props: CreditCard02IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 10H2m9 4H6M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

CreditCard02Icon.displayName = 'CreditCard02Icon'
CreditCard02Icon.defaultProps = iconDefaultProps

export type { CreditCard02IconProps }
export { CreditCard02Icon }
